import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-bottom: var(${(props): string => props.theme.responsive.spacing.xxs});
`;
